import { createFileRoute } from "@tanstack/react-router";
import { commonFaqData } from "@/lib/data/faq-data";
import { servicesListData } from "@/lib/data/services-data";
import {
	generateFAQSchema,
	generateServiceSchema,
} from "@/lib/utils/schema.utils";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/services/")({
	head: () =>
		generateSeo({
			title: "Services - CraftLayer | SEO, SMM, Web Development in Bangalore",
			description:
				"Explore our premium services: SEO to boost rankings, Social Media Marketing (SMM) for brand growth, and Custom Web Development (WordPress, React, Next.js).",
			url: "/services",
			keywords: [
				"SEO services bangalore",
				"social media marketing",
				"web development services",
				"wordpress development",
				"react js development",
				"performance marketing",
			],
		}),
	loader: async () => {
		const faqs = commonFaqData;
		const faqSchema = generateFAQSchema(faqs);

		// Map servicesList to schema format
		const serviceSchemaData = servicesListData.map((service) => ({
			name: service.label,
			url: service.href,
			description: service.description,
		}));
		const serviceSchema = generateServiceSchema(serviceSchemaData);

		return { faqs, faqSchema, serviceSchema };
	},
});
